import CommercialPlaybookSimulator from './CommercialPlaybookSimulator';
import CommercialPlaybookFlow from './CommercialPlaybookFlow';
import React, { useEffect, useState } from 'react';
import { Alert, Button, Form, Spinner } from 'react-bootstrap';
import api from '../../services/leadAutomationService';

const empty = {
  enabled: false, business_segment: '', business_description: '',
  target_audience: '', offers: [], offer_knowledge: [], conversion_goal: '',
  qualification_questions: [], required_lead_fields: ['nome', 'telefone'],
  faq: [], handoff_rules: [], conversion_stage_id: '', closing_message: '',
};
const rows = value => String(value || '').split('\n').map(v => v.trim()).filter(Boolean);
const faqText = value => typeof value === 'string' ? value : (value || [])
  .map(item => item.question + ' | ' + item.answer).join('\n');
const parseFaq = value => rows(value).map(line => {
  const separator = line.indexOf('|');
  return separator < 0 ? null : {
    question: line.slice(0, separator).trim(),
    answer: line.slice(separator + 1).trim(),
  };
}).filter(item => item?.question && item?.answer);
export default function CommercialPlaybookCard() {
  const [simulator,setSimulator]=useState(false);
  const [trace,setTrace]=useState([]);
  const [tab,setTab] = useState('flow');
  const [savedForm,setSavedForm] = useState(empty);
  const [form, setForm] = useState(empty);
  const [faqDraft, setFaqDraft] = useState('');
  const [meta, setMeta] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [notice, setNotice] = useState(null);
  const set = (key, value) => setForm(old => ({ ...old, [key]: value }));

  useEffect(() => {
    api.getCommercialPlaybook().then(data => {
      setForm({ ...empty, ...data.playbook });
      setSavedForm({ ...empty, ...data.playbook });
      setFaqDraft(faqText(data.playbook?.faq));
      setMeta({ mode: data.automation_mode, stages: data.conversion_stages || [] });
    }).catch(() => setNotice(['danger', 'Falha ao carregar o playbook comercial.']))
      .finally(() => setLoading(false));
  }, []);

  const save = async () => {
    setSaving(true);
    setNotice(null);
    try {
      const saved = await api.updateCommercialPlaybook({
        ...form,
        faq: parseFaq(faqDraft),
        conversion_stage_id: form.conversion_stage_id || null,
      });
      setForm({ ...empty, ...saved });
      setSavedForm({ ...empty, ...saved });
      setFaqDraft(faqText(saved.faq));
      setNotice(['success', 'Playbook comercial atualizado.']);
    } catch (error) {
      const errors = error.response?.data?.errors;
      setNotice(['danger', (errors && Object.values(errors).flat()[0])
        || error.response?.data?.message || 'Falha ao salvar.']);
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <Spinner animation="border" />;
  return <section aria-label="Playbook Comercial">
    <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-3">
      <div><h5>Playbook Comercial</h5><small className="text-muted">{form.enabled?'Ativado':'Desativado'} · {JSON.stringify(form)!==JSON.stringify(savedForm)?'Alterações não salvas':'Configuração salva'}</small></div>
      <Button type="button" disabled={saving} onClick={save}>{saving?'Salvando...':'Salvar playbook comercial'}</Button>
    </div>
    <Button className="mb-3" variant="outline-primary" disabled={meta.mode==='clinical'} onClick={()=>setSimulator(true)}>Testar atendimento</Button>
    <div role="tablist" aria-label="Visualização do playbook" className="d-flex flex-wrap gap-2 mb-3">
      <Button type="button" role="tab" aria-selected={tab==='flow'} variant={tab==='flow'?'primary':'outline-secondary'} onClick={()=>setTab('flow')}>Fluxo de atendimento</Button>
      <Button type="button" role="tab" aria-selected={tab==='settings'} variant={tab==='settings'?'primary':'outline-secondary'} onClick={()=>setTab('settings')}>Empresa e ativação</Button>
    </div>
    {meta.mode==='clinical' && <Alert variant="info">O fluxo comercial atende ao CRM sem Consultório. Nesta entidade, o fluxo clínico continua principal.</Alert>}
    {notice && <Alert variant={notice[0]}>{notice[1]}</Alert>}
    {tab==='flow' && <CommercialPlaybookFlow trace={trace} form={{...form,faq:parseFaq(faqDraft)}} disabled={saving} stages={meta.stages || []} onApply={patch=>{setForm(old=>({...old,...patch}));if(patch.faq) setFaqDraft(faqText(patch.faq));}}/>}
    <div hidden={tab!=='settings'}>
    <CompanySettings form={form} saving={saving} set={set} />
    </div>
    <CommercialPlaybookSimulator show={simulator} onHide={()=>setSimulator(false)} form={{...form,faq:parseFaq(faqDraft)}} onTrace={setTrace}/>
  </section>;
}

const CompanySettings = ({ form, saving, set }) => (
  <div style={{ background: '#fff', border: '1px solid #dbeafe', borderRadius: 14, padding: 20, marginBottom: 16 }}>
    <h5>Empresa e ativação</h5>
    <p className="text-muted">Defina o contexto da empresa e ative o atendimento comercial. Edite as etapas e respostas nos cards de Fluxo de atendimento.</p>
    <Form.Check id="commercial-playbook-enabled" className="my-3" type="switch" label="Ativar playbook comercial"
      checked={Boolean(form.enabled)} disabled={saving}
      onChange={event => set('enabled', event.target.checked)} />
    <div className="row g-3">
      <Form.Group className="col-12" controlId="commercial-business-segment">
        <Form.Label>Segmento da empresa</Form.Label>
        <Form.Control value={form.business_segment || ''} disabled={saving}
          onChange={event => set('business_segment', event.target.value)} />
      </Form.Group>
      {[['business_description','Descrição da empresa'],['target_audience','Público-alvo']].map(([key,label]) => (
        <Form.Group className="col-md-6" key={key} controlId={'commercial-'+key}>
          <Form.Label>{label}</Form.Label>
          <Form.Control as="textarea" rows={4} value={form[key] || ''} disabled={saving}
            onChange={event => set(key, event.target.value)} />
        </Form.Group>
      ))}
    </div>
    <p className="small text-muted mt-3 mb-0">Use Salvar playbook comercial no topo para gravar as alterações das duas abas.</p>
  </div>
);
